import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../../../components/Button'
import Field from '../../../../../../../../components/Form/Field'

import {
  facebookPageAccessTokensSelector,
  facebookPagesLeadGenFormsSelector,
  getFacebookPagesLeadGenFormsIsLoadingSelector
} from '../../../../../../../../modules/selectors/socialAccounts'
import { getFacebookPagesLeadGenForms } from '../../../../../../../../modules/actions/socialAccounts'

import { FB_PAGE_CHOICE, LEAD_GEN_FORM } from '../../../../../fields'

import useStyles from './styles'

const RefreshableInstantFormField = ({ formik }) => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { values } = formik

  const facebookPageId = values[FB_PAGE_CHOICE]

  const { [facebookPageId]: selectedPageTokenData } = useSelector(facebookPageAccessTokensSelector)
  const facebookPageAccessToken = selectedPageTokenData?.token

  const facebookPagesLeadGenForms = useSelector(facebookPagesLeadGenFormsSelector)
  const getFacebookPagesLeadGenFormsIsLoading = useSelector(getFacebookPagesLeadGenFormsIsLoadingSelector)

  const formattedLeadGenForms = useMemo(() => {
    return facebookPagesLeadGenForms.map(form => ({
      ...form,
      label: form.name,
      value: form?.id
    }))
  }, [facebookPagesLeadGenForms])

  const getLeadGenFormsHandler = useCallback(() => {
    dispatch(
      getFacebookPagesLeadGenForms({
        id: facebookPageId,
        page_access_token: facebookPageAccessToken
      })
    )
  }, [dispatch, facebookPageId, facebookPageAccessToken])

  useEffect(() => {
    if (facebookPageId && facebookPageAccessToken) {
      getLeadGenFormsHandler()
    }
  }, [getLeadGenFormsHandler, facebookPageId, facebookPageAccessToken])

  return (
    <div className={classes.container}>
      <Field
        className={classes.leadFormField}
        placeholder={t('Instant Form')}
        formik={formik}
        name={LEAD_GEN_FORM}
        options={formattedLeadGenForms}
        isLoading={getFacebookPagesLeadGenFormsIsLoading}
      />
      <Button className={classes.refreshLeadGenFormsButton} type="button" onClick={getLeadGenFormsHandler}>
        {t('Refresh')}
      </Button>
    </div>
  )
}

export default RefreshableInstantFormField
